import React from 'react';

export class ContentManagerDashboard extends React.Component {
  render() {
    return (
      <div className="content-manager-dashboard">

      </div>
    );
  }
}
